import React from "react";
import { cx } from "./Controls";
import type { Verdict } from "../api/types";
import { fmtNum } from "../lib/format";

type Tone = "ok" | "ng" | "warn" | "muted" | "demo" | "ink";

const TONES: Record<Tone, string> = {
  ok: "bg-ok-soft text-ok ring-1 ring-inset ring-ok/25",
  ng: "bg-ng-soft text-ng ring-1 ring-inset ring-ng/25",
  warn: "bg-warn-soft text-warn ring-1 ring-inset ring-warn/25",
  muted: "bg-slate-100 text-slate-600",
  demo: "bg-mark/25 text-ink ring-1 ring-inset ring-mark",
  ink: "bg-ink text-white",
};

export function Badge({ tone, children, title, testId, className }: { tone: Tone; children: React.ReactNode; title?: string; testId?: string; className?: string }) {
  return (
    <span
      title={title}
      data-testid={testId}
      className={cx("tabular inline-flex items-center whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-semibold", TONES[tone], className)}
    >
      {children}
    </span>
  );
}

export function VerdictBadge({ value, testId }: { value: Verdict | null; testId?: string }) {
  if (!value) return <span className="text-slate-400" data-testid={testId}>—</span>;
  return <Badge tone={value === "OK" ? "ok" : "ng"} testId={testId}>{value}</Badge>;
}

export function AiBadge({ result, score, testId }: { result: Verdict | null; score: number | null; testId?: string }) {
  if (!result) return <Badge tone="muted" testId={testId}>Sin IA</Badge>;
  return (
    <Badge tone={result === "OK" ? "ok" : "ng"} title={`Score ${fmtNum(score, 4)}`} testId={testId}>
      {result} · {fmtNum(score, 2)}
    </Badge>
  );
}

export function DemoTag() {
  return <Badge tone="demo" testId="demo-tag">Demo</Badge>;
}
